import React, { FC, useEffect, useState } from "react";
import { IProps } from "./types";
import styles from "./styles.module.scss";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowDownIcon, ArrowSmallDownIcon } from "../../assets";
import { Button, CheckBox } from "..";
import clsx from "clsx";
import { reportTypes, reportCategories } from "../../constants";

const ReportFilter: FC<IProps> = ({
  setIsOpen,
  filterTypes,
  setFilterTypes,
  setFilterCategories,
  filterCategories,
}): JSX.Element => {
  const [isShowTypesList, setIsShowTypesList] = useState(false);
  const [isShowCategoriesList, setIsShowCategroiesList] = useState(false);

  return (
    <motion.div
      initial={{ scale: 0.8, opacity: 0.5 }}
      animate={{ scale: 1, opacity: 1 }}
      className={styles.wrapper}
    >
      <h5 className={styles.title}>Filter</h5>
      <div className={styles.sectionDevider} />
      <div
        onClick={() => setIsShowTypesList((prev) => !prev)}
        className={styles.sectionHeader}
      >
        <span className={styles.sectionTitle}>Type</span>
        <ArrowDownIcon
          className={clsx({
            [styles.arrowOpen]: isShowTypesList,
            [styles.arrowClosed]: !isShowTypesList,
          })}
        />
      </div>
      <AnimatePresence>
        {isShowTypesList && (
          <motion.div
            initial={{ height: 0, marginTop: 0 }}
            animate={{ height: 52, marginTop: 10 }}
            exit={{ height: 0, marginTop: 0 }}
            className={styles.listContainer}
          >
            {reportTypes.map((item, index) => {
              const isChecked = filterTypes.includes(item);
              const onSelect = () => {
                if (isChecked) {
                  setFilterTypes(filterTypes.filter((el) => el !== item));
                } else {
                  setFilterTypes([...filterTypes, item]);
                }
              };

              return (
                <div key={index} className={styles.selectorItem}>
                  <CheckBox isChecked={isChecked} setIsChecked={onSelect} />
                  <span
                    style={{ color: isChecked ? "#11142D" : "#808191" }}
                    className={styles.selectorItemText}
                  >
                    {item}
                  </span>
                </div>
              );
            })}
          </motion.div>
        )}
      </AnimatePresence>
      <div className={styles.sectionDevider} />

      <div
        onClick={() => setIsShowCategroiesList((prev) => !prev)}
        className={styles.sectionHeader}
      >
        <span className={styles.sectionTitle}>Category</span>
        <ArrowDownIcon
          className={clsx({
            [styles.arrowOpen]: isShowCategoriesList,
            [styles.arrowClosed]: !isShowCategoriesList,
          })}
        />
      </div>

      <AnimatePresence>
        {isShowCategoriesList && (
          <motion.div
            initial={{ height: 0, marginTop: 0 }}
            animate={{ height: 86, marginTop: 10 }}
            exit={{ height: 0, marginTop: 0 }}
            className={styles.listContainer}
          >
            {reportCategories.map((item, index) => {
              const isChecked = filterCategories.includes(item);
              const onSelect = () => {
                if (isChecked) {
                  setFilterCategories(
                    filterCategories.filter((el) => el !== item)
                  );
                } else {
                  setFilterCategories([...filterCategories, item]);
                }
              };

              return (
                <div key={index} className={styles.selectorItem}>
                  <CheckBox isChecked={isChecked} setIsChecked={onSelect} />
                  <span
                    style={{ color: isChecked ? "#11142D" : "#808191" }}
                    className={styles.selectorItemText}
                  >
                    {item}
                  </span>
                </div>
              );
            })}
          </motion.div>
        )}
      </AnimatePresence>

      <div className={styles.sectionDevider} />

      <div
        onClick={() => {
          setFilterTypes([]);
          setFilterCategories([]);
        }}
        className={styles.resetButton}
      >
        <div>Reset all filters</div>
      </div>
    </motion.div>
  );
};

export default ReportFilter;
